<script>
  import request from 'superagent';
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import Link from "./Link.svelte";
  import LinkForm from './form/Link.svelte';
  import { submitLink } from "../form/Link.svelte";
  // import SubjectForm from './form/Subject.svelte';
  
  const PAGE_SIZE = 10;
  const defaultSubject = { title: "", about: "", videos: [], links: [], comments: [], links_count: 0, videos_count: 0, comments_count: 0 }
  const dispatch = createEventDispatcher();
  
  export let page = 1;
  export let category_slug = "";
  export let resource = "subjects";
  export let url_prefix = "/ix";
  export let additional_query = "";
  
  let current_url = "";
  let subjects = [];
  let offset = 0;
  let count = 0;
  let ttl = 300; // seconds
  
  afterUpdate(() => {
    getSubjects();
  });
  
  onMount(() => {
    getSubjects(true);
  })
  
  function getSubjects(force_refresh) {
    let url = `${url_prefix}/c/${category_slug}.json?page=${page}`;
    console.log(url)
    if (category_slug == "")
      url = `${url_prefix}.json?page=${page}${additional_query}`;
    if (!force_refresh) {
      if (url == current_url)
        return
      current_url = url;
      var cache = localStorage.getItem(url);
      if (cache){
        cache = JSON.parse(cache);
        if (parseInt(Date.now() / 1000) - cache.t <= ttl) {
          subjects = cache.data;
          count = cache.count;
          offset = cache.offset;
          return;
        }
      }
    }
    fetch(url)
      .then(function(r) {
        if (r.ok) return r;
        throw Error(r.statusText);
      })
      .then(r => r.json())
      .then(data => {
        if (data.count > 0) {
          if (!(Array.isArray(data.data) || data.data instanceof Array))
            subjects = [Object.assign({category_slug}, defaultSubject, data.data)];
          else {
            subjects = [];
            for (var i in data.data)
              subjects.push(Object.assign({category_slug}, defaultSubject, data.data[i]));
          }
        } else
          subjects = [];
        count = data.count;
        page = parseInt(data.page);
        offset = PAGE_SIZE * (page - 1);
        localStorage.setItem(url, JSON.stringify({data: subjects, count, offset, t: parseInt(Date.now() / 1000)}));
        window.scrollTo(0, 0);
        dispatch('IndexOpened', Object.assign({category_slug, page}));
      })
      .catch(function(error) {
        console.log(JSON.stringify(error));
      });
  }
  
  function changePage(p) {
    if (p <= 0 || p > (count/PAGE_SIZE + 1))
      return;
    page = p;
    getSubjects();
  }
  
  function onSubject(m) {
    dispatch('subject', Object.assign({category_slug}, defaultSubject, m));
    return false;
  }
</script>
{#if !subjects}
<div class='jumbotron'>
Nic tu není.
</div>
{/if}
<div class='alert alert-info mb-1'>
Velká část těchto dat potřebuje další péči a ladění.
</div>
<div class='subjects-list list-group'>
{#each subjects as subject, i}
<div class='list-group-subject border-0 mb-3'>
{#if subject.content}
<article>
<section class='meta text-muted badge badge-light badge-lg d-flex flex-row justify-content-between w-100'>
<span>
{subject.content.schema}
</span>
<span>
<a class='text-muted' href='https://cs.wikipedia.org' title='Zdroj'>
<i class='fab fa-wikipedia-w'></i>
</a>
<span class='d-inline-block mx-1'>
{subject.links_count}
<i class='fas fa-external-link-alt'></i>
</span>
</span>
</section>
<div class='d-flex justify-content-between flex-column'>
<h2 class='m-1'>
<a href='{url_prefix}/x/{subject.id}' on:click|preventDefault='{() => onSubject(subject)}' on:keyup|preventDefault='{() => onSubject(subject)}' title='{subject.title}'>{subject.name}</a>
</h2>
</div>
</article>
{/if}
</div>
{/each}
</div>
<div class='margin-auto text-center mt-2'>
{offset} - {offset + PAGE_SIZE} ({count})
</div>
<nav class='nav margin-auto text-center d-flex justify-content-around'>
{#if page-1}
<a class='nav-link' href='?page={page-1}' on:click|preventDefault='{() => changePage(page-1)}' on:keyup|preventDefault='{() => changePage(page-1)}' tinro-ignore>
Předchozí strana
</a>
{/if}
{#if subjects.length && (count - offset > PAGE_SIZE) }
<a class='nav-link' href='?page={page+1}' on:click|preventDefault='{() => changePage(page+1)}' on:keyup|preventDefault='{() => changePage(page+1)}' tinro-ignore>
Další strana
</a>
{/if}
</nav>

